/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { CartDataFragmentDoc } from '../../../hooks/useCart/GraphQL/Cart.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GroupOrderJoinPreviewQueryVariables = Types.Exact<{
  joinCode: Types.Scalars['String']['input'];
}>;

export type GroupOrderJoinPreviewQuery = {
  readonly __typename?: 'Query';
  readonly multipartyOrderPreview:
    | { readonly __typename: 'MultipartyOrderNotFound'; readonly errorMessage: string }
    | {
        readonly __typename: 'MultipartyOrderPreviewSuccess';
        readonly hostDisplayName: string;
        readonly deliveryAddressSummary: string | null;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly name: string;
          readonly isOutpost: boolean;
          readonly address: string;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly slug: string;
        };
      }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string };
};

export type GroupOrderJoinMutationVariables = Types.Exact<{
  input: Types.JoinMultipartyOrderInput;
}>;

export type GroupOrderJoinMutation = {
  readonly __typename?: 'Mutation';
  readonly joinMultipartyOrder:
    | {
        readonly __typename: 'JoinMultipartyOrderSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: {
            readonly __typename?: 'UserOrderPermission';
            readonly canSubmitOrder: boolean;
          };
          readonly multipartyDetails: {
            readonly __typename?: 'MultipartyDetail';
            readonly joinCode: string;
          } | null;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly __typename?: 'SelectedModifier';
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly deliveryFee: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
            readonly deliveryOffset: number;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        };
      }
    | { readonly __typename: 'MultipartyOrderNotFound'; readonly errorMessage: string }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const GroupOrderJoinPreviewDocument = gql`
  query GroupOrderJoinPreview($joinCode: String!) {
    multipartyOrderPreview(joinCode: $joinCode) {
      __typename
      ... on MultipartyOrderPreviewSuccess {
        hostDisplayName
        deliveryAddressSummary
        restaurant {
          __typename
          id
          name
          isOutpost
          address
          city
          state
          zipCode
          slug
        }
      }
      ... on MultipartyOrderNotFound {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
    }
  }
`;

export function useGroupOrderJoinPreviewQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderJoinPreviewQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderJoinPreviewQuery, GroupOrderJoinPreviewQueryVariables>({
    query: GroupOrderJoinPreviewDocument,
    ...options,
  });
}
export const GroupOrderJoinDocument = gql`
  mutation GroupOrderJoin($input: JoinMultipartyOrderInput!) {
    joinMultipartyOrder(input: $input) {
      __typename
      ... on JoinMultipartyOrderSuccess {
        order {
          ...CartData
        }
      }
      ... on MultipartyOrderNotFound {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
      ... on ValidationError {
        message
        fieldErrors {
          field
          message
        }
      }
    }
  }
  ${CartDataFragmentDoc}
`;

export function useGroupOrderJoinMutation() {
  return Urql.useMutation<GroupOrderJoinMutation, GroupOrderJoinMutationVariables>(
    GroupOrderJoinDocument,
  );
}
